import React, { ComponentProps, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../translation/namespace';
import { HeaderCollapsible } from '../../_lib/components/HeaderCollapsible';
import { HeaderCollapsibleModifier } from '../../_lib/components/HeaderCollapsible/HeaderCollapsible';
import { InstantSearchForm } from './partials/InstantSearchForm/InstantSearchForm';
import { GlobalDocumentIds } from '../../types/GlobalDocumentIds';
import IForm from '../../types/IForm';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { GlobalMenuState, useGlobalMenu } from '../../contexts/GlobalMenuStore';
import { BlockGuard } from '../../types/api/Block';
import { accessKeys } from '../../types/AccessKeys';
import bem from '../../lib/bemUtils/bem';

type InstantSearchProps = {
  form: IForm;
  trackingUrl: string;
};
export function InstantSearch({ form, trackingUrl }: InstantSearchProps) {
  const { t } = useTranslation(Namespace.InstantSearch);
  const { currentOpenMenu } = useGlobalMenu();
  const { userInfo } = useAppContext();
  const isOpen = currentOpenMenu === GlobalMenuState.INSTANT_SEARCH;

  const accessKey = userInfo?.settings.accessKeysEnabled ? accessKeys.search : undefined;

  useEffect(() => {
    if (isOpen) {
      document.getElementById(GlobalDocumentIds.instantSearch)?.focus();
    }
  }, [isOpen]);
  return (
    <div className="wrapper__instant-search">
      <div className={bem('instant-search__container', isOpen ? 'expanded' : undefined)}>
        <InstantSearchForm model={form} trackingUrl={trackingUrl} customAccessKey={accessKey} />
      </div>
      <HeaderCollapsible
        id={GlobalDocumentIds.instantSearch}
        title={t('showInstantSearch')}
        modifier={HeaderCollapsibleModifier.SEARCH}
        icon="search-magnifier"
      />
    </div>
  );
}

export const InstantSearchBlock = asBlock(InstantSearch, BlockType.instantsearch);
export type InstantSearchBlock = ComponentProps<typeof InstantSearchBlock>;
export const isInstantSearchBlock = BlockGuard<InstantSearchBlock>(BlockType.instantsearch);
